/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Err_Phone_MaxInputs */

const vi_cdo_err_phone_max = /** @type {(inputs: Cdo_Err_Phone_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại tối đa 20 ký tự`)
};

/**

* @param {Cdo_Err_Phone_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_err_phone_max = /** @type {((inputs?: Cdo_Err_Phone_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Err_Phone_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_err_phone_max(inputs)
});